import { captureException } from "@sentry/nextjs";

export async function fetchCountryCode(): Promise<string> {
  try {
    const response = await fetch("/cdn-cgi/trace");

    if (!response.ok) {
      throw new Error(`${response.statusText} /// ${response.status}`);
    }
    const data = await response.text();
    const locMatch = data.match(/loc=(.*)/);
    if (locMatch) {
      return locMatch[1];
    }
    return "";
  } catch (err) {
    captureException(err);
    return "";
  }
}
